import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { CircularProgress, Box } from '@mui/material';

// requireAdmin 參數表示此路由是否僅限管理員訪問
const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const { isAuthenticated, isAdmin, loading } = useAuth();
  const location = useLocation();

  // 如果仍在加載用戶狀態，顯示載入中界面
  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
        <CircularProgress color="secondary" />
      </Box>
    );
  }

  // 如果未登入，重定向到首頁
  if (!isAuthenticated) {
    // 保存當前位置，以便登入後重定向回來
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // 如果需要管理員權限但用戶不是管理員，導向錯誤頁面或首頁
  if (requireAdmin && !isAdmin) {
    return <Navigate to="/unauthorized" replace />;
  }

  // 允許訪問
  return children;
};

export default ProtectedRoute;